var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SEARCH_SVG, DROP_DOWN_CARRET_SVG, DROP_DOWN_CARRET_BLACK_SVG, BPM_CRATE_EMPTY_BLACK_SVG, BPM_CRATE_BLACK_SVG, BPM_CRATE_SVG, BPM_CRATE_EMPTY_SVG, CLOSE_BLUE_SVG, PLATFORM_SVG, BPM_SOUNDS_LOGO_BLACK_SVG, PLATFORM_GRAY_SVG, BPM_SUPEME_LOGO_BLACK_SVG, BPM_LATINO_LOGO_BLACK_SVG } from "../assets";
import Navbar from "reactstrap/lib/Navbar";
import Nav from "reactstrap/lib/Nav";
import NavItem from "reactstrap/lib/NavItem";
import NavLink from "reactstrap/lib/NavLink";
import { withRouter } from "react-router";
import TextInput from "../components/TextInput";
import { Col, Row, Container, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import BadeView from "../components/BadgeView";
import { ThemeContextConsumer } from "../context/theme";
import { UserContextConsumer } from "../context/user";
import { CrateContextConsumer } from "../context/crate";
import { messages } from "../messages";
import ToggleInput from "../components/ToggleInput";
var HeaderTextFieldOverflowBreakpoint = 200;
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.tempClickPrevent = false;
        _this.state = {
            isOpen: false,
            search: _this.getCurrentSearch(),
            platformOpen: false
        };
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        var _this = this;
        document.addEventListener('click', function () {
            if (_this.tempClickPrevent) {
                _this.tempClickPrevent = false;
                return;
            }
            if (_this.state.platformOpen) {
                _this.setState({ platformOpen: false });
            }
        });
    };
    Header.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.location.pathname !== this.props.location.pathname) {
            this.setState({ search: this.getCurrentSearch(nextProps) });
        }
    };
    Header.prototype.toggle = function () {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    Header.prototype.togglePlatformOpen = function () {
        this.setState({
            platformOpen: !this.state.platformOpen
        });
    };
    Header.prototype.findAncestor = function (el, sel) {
        while ((el = el.parentElement) && !el.classList.contains(sel))
            ;
        return el;
    };
    Header.prototype.search = function (term) {
        if (term != '') {
            var type = 'audio';
            var components = this.props.location.pathname.split('/');
            if (components.includes('video')) {
                type = 'video';
            }
            this.props.history.push('/search/' + type + '/' + encodeURIComponent(term));
        }
    };
    Header.prototype.getCurrentSearch = function (props) {
        if (props === void 0) { props = this.props; }
        if (props.match.params.page == 'search') {
            var components = props.location.pathname.split('/');
            if (components.length >= 4) {
                return decodeURIComponent(components[3]);
            }
        }
        return '';
    };
    Header.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContextConsumer, null, function (theme) {
            return React.createElement("div", { className: "header-container" },
                React.createElement("div", { className: "logo-item", onClick: _this.props.onLogoClick }),
                React.createElement(Navbar, { color: "themed", className: "header" },
                    React.createElement("div", { className: "navbar-scrollable" },
                        React.createElement(Nav, { navbar: true }, _this.props.pages.map(function (item, index) {
                            var active = _this.props.match.params.page == item.path;
                            return React.createElement(NavItem, { active: active, key: index, className: "header-nav-item nav-" + item.path },
                                React.createElement(NavLink, { href: "javascript:void(0)", onClick: function () {
                                        _this.props.history.push('/' + item.path);
                                    } },
                                    React.createElement("span", { className: "align-middle nav-centered-container" },
                                        item.icon && React.createElement("img", { src: active ? item.icon_selected : (theme == 'black' ? item.icon_black : item.icon), height: item.icon_height }),
                                        React.createElement("span", null, item.title)),
                                    React.createElement("div", { className: "active-border" })));
                        }))),
                    React.createElement("div", { className: "header-right" },
                        React.createElement(Container, { style: { marginRight: 'auto' } },
                            React.createElement(Row, { className: "no-wrap header-right-row" },
                                React.createElement(Col, { className: "my-auto search-column", key: _this.getCurrentSearch() },
                                    React.createElement(TextInput, { placeholder: /*'Search…'*/ '', icon: SEARCH_SVG, onFocus: function (e) {
                                            if (e.target.clientWidth < HeaderTextFieldOverflowBreakpoint) {
                                                var parentRow = _this.findAncestor(e.target, 'header-right-row');
                                                if (parentRow) {
                                                    parentRow.classList.add('search-overflow');
                                                    parentRow = _this.findAncestor(parentRow, 'header');
                                                    if (parentRow) {
                                                        parentRow.classList.add('search-workaround');
                                                    }
                                                }
                                            }
                                        }, onBlur: function (e) {
                                            var parentRow = _this.findAncestor(e.target, 'header-right-row');
                                            if (parentRow) {
                                                parentRow.classList.remove('search-overflow');
                                                parentRow = _this.findAncestor(parentRow, 'header');
                                                if (parentRow) {
                                                    parentRow.classList.remove('search-workaround');
                                                }
                                            }
                                        }, onIconClick: function (e, input) {
                                            if (input.clientWidth < HeaderTextFieldOverflowBreakpoint) {
                                                var parentRow = _this.findAncestor(input, 'header-right-row');
                                                if (parentRow) {
                                                    parentRow.classList.add('search-overflow');
                                                    parentRow = _this.findAncestor(parentRow, 'header');
                                                    if (parentRow) {
                                                        parentRow.classList.add('search-workaround');
                                                    }
                                                    input.focus();
                                                    return;
                                                }
                                            }
                                            _this.search(input.value);
                                        }, onKeyDown: function (e) {
                                            if (e.keyCode == 13) {
                                                _this.search(e.currentTarget.value);
                                                e.currentTarget.blur();
                                            }
                                        }, rightIcon: _this.state.search != '' ? CLOSE_BLUE_SVG : undefined, onRightIconClick: function (_e) {
                                            _this.setState({ search: '' });
                                        }, value: _this.state.search, onChange: function (e) {
                                            _this.setState({ search: e.target.value });
                                        } })),
                                _this.props.onThemeChange && React.createElement(Col, { style: { paddingRight: 0, flex: '0 0 65px' }, className: "my-auto" },
                                    React.createElement(ToggleInput, { checked: theme == 'white', onChange: function (e) {
                                            _this.props.onThemeChange(e.target.checked ? 'white' : 'black');
                                        } })),
                                React.createElement(CrateItem, { enableDrag: _this.props.enableDrag, theme: theme, onNavigateToCrate: _this.props.onNavigateToCrate }),
                                (_this.props.onBPMCreateClick || _this.props.onBPMLatinoClick || _this.props.onBPMSupremeClick) && React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: "platform hide-mobile", style: { position: 'relative', justifyContent: 'center', display: 'flex', flexDirection: 'column' }, onClick: function (e) {
                                            _this.tempClickPrevent = true;
                                            _this.togglePlatformOpen();
                                        } },
                                        React.createElement(UserContextConsumer, null, function (user) {
                                            return React.createElement("img", { src: user.theme == 'black' ? PLATFORM_GRAY_SVG : PLATFORM_SVG });
                                        })),
                                    React.createElement("div", { className: 'platform-selection ' + (_this.state.platformOpen ? 'slide-down fadeToggle' : 'slide-up') },
                                        React.createElement("div", { className: "switch-text" }, "Switch to:"),
                                        React.createElement("div", { className: "divider" }),
                                        _this.props.onBPMCreateClick && React.createElement("div", { className: 'platform-selection-item', onClick: function () {
                                                _this.props.onBPMCreateClick();
                                            } },
                                            React.createElement("div", { className: 'img' },
                                                React.createElement(UserContextConsumer, null, function (user) {
                                                    return React.createElement("img", { src: BPM_SOUNDS_LOGO_BLACK_SVG });
                                                }))),
                                        _this.props.onBPMSupremeClick && React.createElement("div", { className: 'platform-selection-item', onClick: function () {
                                                _this.props.onBPMSupremeClick();
                                            } },
                                            React.createElement("div", { className: 'img' },
                                                React.createElement(UserContextConsumer, null, function (user) {
                                                    return React.createElement("img", { src: BPM_SUPEME_LOGO_BLACK_SVG });
                                                }))),
                                        _this.props.onBPMLatinoClick && React.createElement("div", { className: 'platform-selection-item', onClick: function () {
                                                _this.props.onBPMLatinoClick();
                                            } },
                                            React.createElement("div", { className: 'img' },
                                                React.createElement(UserContextConsumer, null, function (user) {
                                                    return React.createElement("img", { src: BPM_LATINO_LOGO_BLACK_SVG });
                                                }))))),
                                React.createElement(Col, { style: { paddingLeft: 0, paddingRight: 0, flex: '0 0 85px' }, className: "my-auto" },
                                    React.createElement(ButtonDropdown, { isOpen: _this.state.isOpen, toggle: _this.toggle, direction: 'down' },
                                        React.createElement(DropdownToggle, { className: "account-menu-toggle", color: "themed", caret: true },
                                            React.createElement("div", { style: { width: '28px', height: '28px' } },
                                                React.createElement(UserContextConsumer, null, function (user) {
                                                    return React.createElement(React.Fragment, null,
                                                        user.profile_image_thumbnail_url && React.createElement("div", { style: { width: '28px', height: '28px', backgroundImage: "url('" + user.profile_image_thumbnail_url + "')", backgroundSize: 'cover', backgroundPosition: 'center center', borderRadius: '50%' } }),
                                                        !user.profile_image_thumbnail_url && React.createElement("img", { className: "profile-icon", src: _this.props.BPM_LOGO_SVG }));
                                                })),
                                            React.createElement("img", { src: theme == 'black' ? DROP_DOWN_CARRET_BLACK_SVG : DROP_DOWN_CARRET_SVG, width: 12, style: { marginLeft: 8, alignSelf: 'center' } })),
                                        React.createElement(DropdownMenu, { right: true, className: 'account-menu' },
                                            React.createElement(UserContextConsumer, null, function (user) {
                                                return React.createElement(React.Fragment, null,
                                                    React.createElement(DropdownItem, { disabled: true, className: 'username' },
                                                        React.createElement("span", null, user.username)),
                                                    React.createElement(DropdownItem, { disabled: true, className: 'userid' },
                                                        React.createElement("span", null,
                                                            messages.CustomerId,
                                                            ": ",
                                                            user.id)));
                                            }),
                                            React.createElement(DropdownItem, { onClick: function () {
                                                    _this.props.history.push('/account');
                                                } },
                                                React.createElement("span", { style: { marginLeft: '2px' } }, "My Account")),
                                            React.createElement(DropdownItem, { onClick: function () {
                                                    _this.props.history.push('/');
                                                } },
                                                React.createElement("span", null, messages.Home)),
                                            (function () {
                                                if (!_this.props.onMembershipChangeClick) {
                                                    return null;
                                                }
                                                if ((['Premium', 'PremiumPlus'].includes(_this.props.membershipType)
                                                    && (!_this.props.membershipExpired)))
                                                    return null;
                                                else {
                                                    return (React.createElement(DropdownItem, { onClick: function () {
                                                            _this.props.onMembershipChangeClick();
                                                        } },
                                                        React.createElement("span", null, ['None', undefined].includes(_this.props.membershipType)
                                                            ? messages.GetMembership
                                                            : messages.UpgradeMembership)));
                                                }
                                            })(),
                                            _this.props.onSupport && React.createElement(DropdownItem, { onClick: function () {
                                                    _this.props.onSupport();
                                                } },
                                                React.createElement("span", null, messages.Support)),
                                            _this.props.onContact && React.createElement(DropdownItem, { onClick: function () {
                                                    _this.props.onContact();
                                                } },
                                                React.createElement("span", null, messages.Contact)),
                                            _this.props.onEnterFullScreen && React.createElement(DropdownItem, { onClick: function () {
                                                    _this.props.onEnterFullScreen();
                                                } },
                                                React.createElement("span", null, _this.props.isFullScreen ? messages.ExitFullScreen : messages.Fullscreen)),
                                            React.createElement(DropdownItem, { onClick: function () {
                                                    _this.props.onLogout();
                                                } },
                                                React.createElement("span", null, messages.Logout))))))))));
        }));
    };
    return Header;
}(React.Component));
export default withRouter(Header);
var CrateItem = function (_a) {
    var theme = _a.theme, onNavigateToCrate = _a.onNavigateToCrate;
    var _b = React.useState(false), isActive = _b[0], setIsActive = _b[1];
    return React.createElement("div", { onDragEnter: function (e) {
            e.preventDefault();
            setIsActive(true);
        }, onDragOver: function (e) {
            e.preventDefault();
            setIsActive(true);
        }, onDragLeave: function () {
            setIsActive(false);
        }, onDrop: function (e) {
            var id = e.dataTransfer.getData('Text');
            var elem = document.getElementById(id);
            if (elem) {
                try {
                    elem.dispatchEvent(new Event('add_to_crate'));
                }
                catch (error) {
                }
            }
            setIsActive(false);
        }, style: { justifyContent: 'center', display: 'flex', flexDirection: 'column' } },
        React.createElement(Col, { style: { paddingLeft: 0, paddingRight: 0, flex: '0 0 40px' }, className: "my-auto crate" },
            React.createElement(NavLink, { href: "javascript:void(0)", onClick: function () {
                    onNavigateToCrate();
                }, className: isActive ? 'crate-drag-active' : '' },
                React.createElement(CrateContextConsumer, null, function (crate) {
                    return React.createElement(BadeView, { icon: theme == 'black' ? (crate.length > 0 ? BPM_CRATE_BLACK_SVG : BPM_CRATE_EMPTY_BLACK_SVG) : (crate.length > 0 ? BPM_CRATE_SVG : BPM_CRATE_EMPTY_SVG), width: isActive ? 44 : 36, badge: crate.length });
                }))));
};
//# sourceMappingURL=Header.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/layout/Header.js
// module id = 1325
// module chunks = 0